import { GO_TO_DASHBOARD } from "@/app/(protected)/pdp-copy/components/GeneratedCopy/constants";
import { GTM_EVENT_PAGE_NAMES, URLS } from "@/constants/constants";
import HomeIcon from "@icons/home/home-white.svg";
import RefineIcon from "@icons/refine/refine-white.svg";
// test commit

export const GENERATED_ASSETS_CONSTANT = {
  HEADING: "Your asset is ready",
  HEADING_INFO: `Your content is now available in the “Saved work” area. Please note: Assets are not ready to produce until they have completed proper legal review and approval.`,
  BUTTON_TEXT: "Create another asset",
  PROJECT_NAME: "oreo new year promotion",
  CREATE_NEW_ASSETS: "Create new assets",
};

export const REPLACE_ALL_TEXT = ({ isIncludeImage = false }: { isIncludeImage?: boolean }) => {
  return {
    Text: "Replace all text",
    Image: "Replace Image",
    "Image + description": "Replace all",
    "Video Script": isIncludeImage ? "Replace all" : "Replace all text",
  };
};

export const REPLACE_ALL_TITLE = "Want to keep any";
export const REPLACE_ALL_PROMPT_TEXT = ({ isIncludeImage = false }: { isIncludeImage?: boolean }) => {
  return {
    Text: "text",
    Image: "images",
    "Image + description": "text or images",
    "Video Script": isIncludeImage ? "text or images" : "text",
  };
};

export const REPLACE_ALL_DESCRIPTION =
  "So as not to overwrite your work, we recommend downloading any assets you want to keep now. Please keep in mind token usage and the overall impact on sustainability.";
export const REPLACE_ALL_YES_TEXT = "Yes, replace";

export const NEXT_ACTIVITY = {
  title: "What would you like to do next?",
  activities: [
    {
      href: URLS.HOME,
      title: GO_TO_DASHBOARD,
      description: `You can view or download your creations anytime from the dashboard.`,
      icon: HomeIcon,
      pageName: GTM_EVENT_PAGE_NAMES.GENERATED_ASSETS,
    },
    {
      href: "",
      title: "Refine details",
      description: "Make adjustments and tailor your results.",
      icon: RefineIcon,
      pageName: GTM_EVENT_PAGE_NAMES.GENERATED_ASSETS,
      className: "event_refine_details_click",
    },
    {
      href: "",
      title: GENERATED_ASSETS_CONSTANT.CREATE_NEW_ASSETS,
      description: "Continue on within your workflow and create more assets.",
      icon: RefineIcon,
      pageName: GTM_EVENT_PAGE_NAMES.GENERATED_ASSETS,
      className: "event_refine_details_click",
    },
  ],
};

export const ReportAnIssue = {
  title: "Feel free to",
  href: "https://mdlz.service-now.com/technology",
  description: "if you have concerns about your concepts or this tool.",
  reportText: "report an issue",
};

export const UpscaleAssetTitle = "upscale-asset-title";

const NUMBER_DESC: Record<number, string> = {
  1: "one",
  2: "two",
  3: "three",
  4: "four",
};

export const CREATE_MORE_LIKE_THIS_TITLE = (count: number) => {
  const word = NUMBER_DESC[count] ?? count.toString();
  return `Are you sure you want to create ${word} (${count}) new image${count > 1 ? "s" : ""}?`;
};

export const CREATE_MORE_LIKE_THIS_DESC = (count: number) => {
  const word = NUMBER_DESC[count] ?? count.toString();
  return `If you click "Yes, replace," ${word} (${count}) new image${count > 1 ? "s" : ""} will be replaced and you will not be able to return to any previous versions.`;
};

export const MAX_RETRIES = 3;
export const RETRY_DELAY_MS = 500;

export const FLOW_TYPE_ASSET_GEN = "assetgen";
